import { HTTP, buildQueries } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";
export function callApiLayChiTietNguoiDung(endpoint, payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${endpoint}/${payload.id}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachCanBoLayVaoNguoiDung(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.USER.DANH_SACH_CAN_BO_LAY_VAO_NGUOI_DUNG}?${buildQueries(
        payload
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayNguoiDungGomQuyen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.USER.NGUOI_DUNG_GOM_QUYEN}?${buildQueries(payload)}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiTaoMoiNguoiDung(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.USER.TAO_MOI_NGUOI_DUNG}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiThayDoiMatKhau(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.put(`${ENDPOINT.USER.CHANGE_PASSWORD}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiResetMatKhau(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.put(`${ENDPOINT.USER.RESET_PASSWORD}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiCapNhatMatKhauNguoiDung(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.put(`${ENDPOINT.USER.RESET_PASSWORD_NGUOI_DUNG}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiCapNhatNguoiDung(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.put(`${ENDPOINT.USER.CAP_NHAT_NGUOI_DUNG}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiXoaNguoiDung(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.delete(`${ENDPOINT.USER.XOA_NGUOI_DUNG}${payload.id}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachVaiTroTheoNguoiDung(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.USER.DANH_SACH_VAI_TRO_THEO_NGUOI_DUNG}?${buildQueries(
        payload
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachVaiTroKhongThuocNguoiDung(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.USER.DANH_SACH_VAI_TRO_KHONG_THUOC_NGUOI_DUNG}?${buildQueries(
        payload
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachGroupTheoNguoiDung(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.USER.DANH_SACH_GROUP_THEO_NGUOI_DUNG}?${buildQueries(
        payload
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachGroupKhongThuocNguoiDung(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.USER.DANH_SACH_GROUP_KHONG_THUOC_NGUOI_DUNG}?${buildQueries(
        payload
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachQuyenTheoNguoiDung(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.USER.DANH_SACH_QUYEN_THEO_NGUOI_DUNG}?${buildQueries(
        payload
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachQuyenKhongThuocNguoiDung(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.USER.DANH_SACH_QUYEN_KHONG_THUOC_NGUOI_DUNG}?${buildQueries(
        payload
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiCapNhatVaiTroTheoNguoiDung(payload, endpoint) {
  return new Promise((resolve, reject) => {
    const newPayload = {
      roleIds: payload.roleIds,
      deleteRoleIds: payload.deleteRoleIds
    };
    return HTTP.put(`${endpoint}/${payload.id}/roles`, newPayload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiCapNhatQuyenTheoNguoiDung(payload, endpoint) {
  return new Promise((resolve, reject) => {
    const newPayload = {
      permissionIds: payload.permissionIds,
      deletePermissionIds: payload.deletePermissionIds
    };
    return HTTP.put(`${endpoint}/${payload.id}/permissions`, newPayload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiCapNhatEmailNguoiDung(payload, endpoint) {
  return new Promise((resolve, reject) => {
    const newPayload = {
      email: payload.email
    };
    return HTTP.put(`${endpoint}/${payload.id}/email`, newPayload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiCapNhatActivelNguoiDung(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.put(`${endpoint}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachNguoiDungTheoGroup(payload) {
  return HTTP({
    url: ENDPOINT.USER.DANH_SACH_NGUOI_DUNG_THEO_GROUP,
    method: "GET",
    params: payload
  });
}

export function callApiLayDanhSachNguoiDungKhongThuocVaiTro(payload) {
  return HTTP({
    url: ENDPOINT.USER.DANH_SACH_NGUOI_DUNG_NOT_IN_ROLE,
    method: "GET",
    params: payload
  });
}

export function callApiLayDanhSachNguoiDungTheoVaiTro(payload) {
  return HTTP({
    url: ENDPOINT.USER.DANH_SACH_NGUOI_DUNG_THEO_ROLE,
    method: "GET",
    params: payload
  });
}

export function callApiAddMapping(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.USER.ADD_MAPPING, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiRemoveMapping(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.USER.REMOVE_MAPPING, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayNguoiDungKhongThuocCanBo(payload) {
  return HTTP({
    url: ENDPOINT.USER.DANH_SACH_NGUOI_DUNG_NOT_IN_CAN_BO,
    method: "GET",
    params: payload
  });
}

export function callApiAddOrUpdateObjectPermisions(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.USER.ADD_OR_UPDATE_OBJECT_PERMISSION, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiRemoveItemObjectPermissionUser(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.USER.REMOVE_ITEM_OBJECT_PERMISSION, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiActivePermissionUser(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.USER.ACTIVE_PERMISSION, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiXoaPhamViQuyenUser(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.USER.XOA_PHAM_VI_QUYEN, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiResetQRUser(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.USER.RESET_QR, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
  });
}
